import {
  MdHomeFilled,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
} from "react-icons/md";
import { Link, Routes, Route, useParams, useNavigate } from "react-router-dom";
import "../../components/MyTabCits.scss";
function Committeeprocess() {
  let navigate = useNavigate();
  return (
    <div className="">
      <div className="">
        <div className="my_page bbs_contain">
          <Routes>
            <Route path=":id" element={"sdfa"} />
          </Routes>

          <div className="row_bbs bbs_customqa_wrap">
            <table className="table_wrap_customerqa">
              <thead>
                <tr>
                  <th>접수번호</th>
                  <th>접수분야</th>
                  <th>신청분야</th>
                  <th>접수일</th>
                  <th>처리상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="num_bbs">RN-20220128-0001</td>
                  <td>
                    <p>불만</p>
                  </td>
                  <td>
                    <p className="auth">인정</p>
                  </td>
                  <td className="date_bbs">2022-01-28 13:56:51</td>
                  <td className="date_bbs">종료</td>
                </tr>
                <tr>
                  <td className="num_bbs">RN-20220128-0001</td>
                  <td>
                    <p>이의제기</p>
                  </td>
                  <td>
                    <p className="auth">인정</p>
                  </td>
                  <td className="date_bbs">2022-01-28 13:56:51</td>
                  <td className="date_bbs">검토중</td>
                </tr>
              </tbody>
            </table>

            <div className="pagination_wrap">
              <div></div>
              <div className="pagination">
                <button className="left_arrow">
                  <MdKeyboardArrowLeft />
                </button>
                <div className="pages">
                  <span>1</span>
                  <span>2</span>
                </div>
                <button className="right_arrow">
                  <MdKeyboardArrowRight />
                </button>
              </div>
              <div>
                <button
                  style={{ visibility: "hidden" }}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/breakdown/cits");
                  }}
                  className="list_btn"
                >
                  {/* 목록 */}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Committeeprocess;
